module.exports = __webpack_public_path__ + "static/media/sad_icon.d52004f7.svg";